/* RALICA CARD VARIANT SWITCH */
$( ".block-swatch__radio.rlcp" ).on( "click", function(event) {
  
   setTimeout(() => {
   
   location.reload(); 
 }, "250");
} );

/* TBI HIDDEN PRICE*/
//  setTimeout(() => {
//    $('.tbi-hidden-price').addClass("line-item__price");
//  }, "2000");
  

/* TOGGLE FILTERS */
  $('.collection__filter-group').first().find(".collection__filter-group-name").click();
  $('.collection__filter-group').first().next().find(".collection__filter-group-name").click();

 // setTimeout(() => {

   /*
  $('ul[role="list"] li:contains("Специална цена")').show();
  $('ul[role="list"] li:contains("На склад")').show();
  $('ul[role="list"] li:contains("Бърза доставка")').show();
  $('.collection__filter-checkbox:contains("(0)")').hide();
  */
 // }, "300");

/*
$( "body" ).on( "click", function() {
   setTimeout(() => {
  $('.collection__filter-checkbox:contains("(0)")').hide();
 }, "1000");
} );
*/

/* LEASING BUTTONS */

// setTimeout(() => {
//     $( "#dsk_btn" ).css("display","block");
//     //$( "#unicredit_button" ).css("display","flex");
// }, "1000");

// var p_id = null;
// var p_name = null;
// var p_qty = null;
// var p_image = null;
// var p_price = null;
// if (typeof DSK_total !== 'undefined') {
//   // the variable is defined
// } else {
//   let DSK_total = p_price;
// }

// const initDsk = () => {
//   const dskBtn = document.getElementById('dsk_btn');

//   if (!dskBtn) return;

//   dskBtn.addEventListener('click', (e) => {
//     var DSK_object = [];

//     const $this = e.target;
//     p_id = $this.dataset.productId;
//     p_name = $this.dataset.productTitle;
//     if (!document.querySelector('.product-form')) {
//       p_qty = parseInt(document.querySelector('.line-item__quantity .quantity-selector__value').value);
//       // p_image = document.querySelector('.line-item__product-info img').src;
//       p_price = $this.dataset.productPrice;
//     } else {
//       p_qty = parseInt(document.querySelector('.quantity-selector--product .quantity-selector__value').value);
//       p_image = document.querySelector('.product-gallery__image').src;
//       p_price = $this.dataset.productPrice;
//     }
//     let DSK_total = p_price;

//     let DSK_product = {
//       products_id: p_id,
//       products_name: p_name,
//       products_q: p_qty,
//       products_p: p_price,
//       products_i: p_image
//     };

//     DSK_object.push(DSK_product);

//     let encodedObject = encodeURIComponent(JSON.stringify(DSK_object));
//     //let toURL = 'https://www.lhost.bg/project/dskcredit/ralicadskpay.php?products=' + encodedObject + '&total=' + DSK_total;
//     //let toURL = 'https://www.themar2.com/DSKcredit/ralicadskpay.php?products=' + encodedObject + "&total=" + DSK_total;
//     let DSK_toURL = 'https://dev.isu.bg/ralica-credits/ralicadskpay.php?products=' + encodedObject + "&total=" + DSK_total;
    

//     // console.log(toURL);
//     window.open(DSK_toURL, '_blank');
//     //$("#dsk_popup_iframe").attr("src", toURL);
//     //var theFrame = '<iframe id="dsk_popup_iframe" src="' + toURL + '" scrolling="auto" width="100%" height="100%" frameborder="0"></iframe>'
//     //$(".dsk-container").css("display","flex");
//   });

//   $('.dsk-container').on('click', function () {
//     $('.dsk-container').css('display', 'none');
//   });
//   //console.log(toURL);
//   // $( "#dsk_btn" ).on( "click", function() {
//   //   //console.log(toURL);
//     // window.open(DSK_toURL, '_blank');
//   // });

// };
// initDsk();
// window.initDsk = initDsk;


/* ------------------------------------------------------------ *\
/* ------------------------------------------------------------ *\
/* ------------------------------------------------------------ *\
/* ------------------------------------------------------------ *\
/* ------------------------------------------------------------ *\

                  Gloross updates - 12.06.2024

/* ------------------------------------------------------------ *\
/* ------------------------------------------------------------ *\
/* ------------------------------------------------------------ *\
/* ------------------------------------------------------------ *\
\* ------------------------------------------------------------ */


/* ------------------------------------------------------------ *\
  Ticker component
\* ------------------------------------------------------------ */
if (!customElements.get('ticker-component')) {
  customElements.define('ticker-component', class ticker extends HTMLElement {
    constructor() {
      super();

      this.ticker = this.querySelector('[data-ticker]');
      this.items = this.querySelector('[data-ticker-items]');
      this.isRunning = false;
      this.isPaused = false;
      this.timeIndex = Number(this.dataset.speed) || 1.63; // seconds
      this.space = 100; // px, animate through "space" px for "timeIndex" seconds
      this.forcePlay = this.dataset.forcePlay == 'true' ? true : false;
      this.sourceContainer = this.ticker.children[0];
      this.textIsBiggerThanContainer = this.sourceContainer.clientWidth > this.ticker.clientWidth;
      this.animationContainers = Array.from(this.ticker.children);
      this.classes = { paused: 'paused' };

      this.init();
    }

    updateAnimationContainers() {
      this.animationContainers = Array.from(this.ticker.children);
    }

    updateSourceContainer() {
      if (!this.ticker.children.length) throw new Error('Child container not found in announcement-bar-ticker.liquid');
      this.sourceContainer = this.ticker.children[0];
    }

    updateTextIsBiggerThanContainer() {
      this.textIsBiggerThanContainer = this.sourceContainer.clientWidth > this.ticker.clientWidth;
    }

    init() {
      this.setAnimationCSSVariable();
      this.handleAnimation();
      
      window.addEventListener('load', () => {
        this.updateTicker();
      });

      window.addEventListener('resize', () => {
        this.updateTicker();
      });

      this.addEventListener('mouseenter', () => {
        this.pause();
      });

      this.addEventListener('mouseleave', () => {
        this.play();
      });
    }

    updateVariables() {
      this.updateSourceContainer();
      this.updateTextIsBiggerThanContainer();
      this.updateAnimationContainers();
    }

    updateTicker() {
      this.updateVariables();
      this.handleAnimation();
    }
    
    setAnimationCSSVariable() {
      const animationTimeFrame = (this.sourceContainer.clientWidth / this.space) * this.timeIndex;
      this.ticker.style.setProperty('--animation-time', `${animationTimeFrame.toFixed(1)}s`);
    }

    handleAnimation() {
      if (this.forcePlay) {
        this.animate();
      } else {
        this.animateWhenNecessary();
      }

      // We need to restart the animation when we add more items to avoid аnimation desync
      this.resetAnimation();
    }

    animate() {
      // Keep cloning the items until marquee starts to overflow
      // and then add one additional item to ensure we have enough items to properly animate
      while (
        this.ticker.scrollWidth <=
        this.ticker.clientWidth + this.sourceContainer.getBoundingClientRect().width
      ) {
        this.cloneAndAppendItems();
      }

      this.play();
    }
    
    animateWhenNecessary() {
      if (this.textIsBiggerThanContainer) {
        if (this.isRunning) return;

        this.cloneAndAppendItems();
      } else {
        if (this.animationContainers.length < 2) return;
        
        const [_originalItem, ...clones] = this.animationContainers;
        clones.forEach((clone) => clone.remove()); // Kill clones only and keep the original item, the ticker is now paused
        this.updateVariables();
      }

      this.isRunning = this.textIsBiggerThanContainer;
      this.isPaused = !this.textIsBiggerThanContainer;
      this.querySelectorAll('[data-ticker-items]').forEach((element) => element.classList.toggle('paused', !this.textIsBiggerThanContainer));

      if (!this.forcePlay) this.ticker.style.transform = '';
    }

    cloneAndAppendItems() {
      const clone = this.sourceContainer.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true'); // Prevent voice-over from announcing the clones
      this.ticker.appendChild(clone); // Add clones
      this.updateVariables();
    }

    resetAnimation() {
      this.animationContainers.forEach((element) => {
        element.style.animation = 'none';
        setTimeout(() => {
          element.style.animation = '';
        }, 50);
      });
    }

    play() {
      this.ticker.style.transform = '';

      if (this.forcePlay || this.textIsBiggerThanContainer) {
        this.isRunning = true;
        this.isPaused = false;
        this.items.classList.remove(this.classes.paused);
      }
    }

    pause() {
      this.isPaused = true;
      this.items.classList.add(this.classes.paused);
    }
  });
}

/* Calc full-screen height */
const calcVariables = () => {
  const headerHeight = document.querySelector('.shopify-section__header')?.clientHeight;
  const windowHeight = window.innerHeight;
  const announcementBarHeight = document.querySelector('.shopify-section--announcement-bar')?.clientHeight;
  document.documentElement.style.setProperty('--full-screen', `${windowHeight}px`);
  headerHeight && document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  announcementBarHeight && document.documentElement.style.setProperty('--announcement-bar-height', `${announcementBarHeight}px`);
}

calcVariables();

window.addEventListener('resize', () => {
  calcVariables();
});

/* Mobile Menu & Cart Drawer buttons */
(() => {
  const menuButton = document.querySelector('.header__mobile-nav');
  const cartButton = document.querySelector('.header__action-item--cart');
  const header = document.querySelector('.header');
  
  const lockBody = () => {
    const bodyIsLocked = document.body.classList.contains('no-mobile-scroll');
    bodyIsLocked 
      ? bodyScrollLock.disableBodyScroll(header)
      : bodyScrollLock.enableBodyScroll(header);
  }

  menuButton?.addEventListener('click', lockBody);
  cartButton?.addEventListener('click', lockBody);

  document.addEventListener('click', () => {
    if (!document.body.classList.contains('no-mobile-scroll')) {
      document.body.classList.remove('no-mobile-scroll');
      requestAnimationFrame(() => {
        document.body.style.overflow = '';
      });
    }
  });
})();

/* ------------------------------------------------------------ *\
  Modal
\* ------------------------------------------------------------ */

document.addEventListener('DOMContentLoaded', function () {
  // Open modal buttons
  this.buttonsOpenModal = document.querySelectorAll('[data-modal-open]');
  this.buttonsOpenModal.forEach(button => {
    button.addEventListener('click', (event) => {
      event.preventDefault();

      const modalId = button.dataset.modalOpen;
      const modal = document.querySelector(modalId);
      if (modal) {
        modal.open();
      } else {
        console.warn('Modal not found');
      }
    });
  });
  
  if (!customElements.get('modal-component')) {
    customElements.define('modal-component', class ModalComponent extends HTMLElement {
      constructor() {
        super();
        this.closeButtons = this.querySelectorAll('[data-modal-close]');
        this.classes = {
          isVisible: 'is-visible'
        }

        this.init()
      }

      init() {
        this.closeButtons.forEach(button => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            this.close();
          });
        });
        
        this.addEventListener('modal:open', () => {
          this.open();
        });
        
        this.addEventListener('modal:close', () => {
          this.close();
        });
      }

      open() {
        this.classList.add(this.classes.isVisible);
        bodyScrollLock.disableBodyScroll(this);
        document.body.classList.add('no-mobile-scroll');
        this.dispatchEvent(new Event('modal:opened'));
      }

      close() {
        this.classList.remove(this.classes.isVisible);
        bodyScrollLock.enableBodyScroll(this);
        document.body.classList.remove('no-mobile-scroll');
        this.dispatchEvent(new Event('modal:closed'));
      }
    });
  }
});
